import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { watch } from "vue";
import * as Views from "../views";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "process",
    component: Views.SignatureView,
    /*children: [
      {
        path: "/child-path",
        name: "child",
        component: Views.child,
      },
    ],*/
  },
  {
    path: "/:catchAll(.*)",
    component: Views.V404View,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

watch(
  () => router.currentRoute,
  async () => {
    console.log("route fullPath updated", router.currentRoute);
  }
);

export default router;
